import React, { useContext } from 'react';
import { PremiumLocaleContext } from '../../providers/PremiumLocaleProvider/PremiumLocaleProvider';
import { formatCurrency } from './formatCurrency';
import { formatCurrencyToParts } from './formatCurrencyToParts';
export var usePremiumCurrencyFormatter = function usePremiumCurrencyFormatter(props) {
  if (props === void 0) {
    props = {};
  }
  var context = useContext(PremiumLocaleContext);
  var getCurrencyFormatter = function getCurrencyFormatter(currencySettings) {
    return function (amount, formatConfig) {
      return formatCurrency(amount, currencySettings, formatConfig);
    };
  };
  var getPartsFormatter = function getPartsFormatter(currencySettings) {
    return function (amount, formatConfig) {
      return formatCurrencyToParts(amount, currencySettings, formatConfig);
    };
  };
  var currencySettings = props.currencySettings || context.currencySettings;
  var selectedCurrencySettings = currencySettings[props.currencyCode || context.currencyCode];
  return [getCurrencyFormatter(selectedCurrencySettings), getPartsFormatter(selectedCurrencySettings)];
};